import { render, staticRenderFns } from "./CampaignStepTemplateConfig.vue?vue&type=template&id=9242c968&scoped=true"
import script from "./CampaignStepTemplateConfig.vue?vue&type=script&lang=js"
export * from "./CampaignStepTemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./CampaignStepTemplateConfig.vue?vue&type=style&index=0&id=9242c968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9242c968",
  null
  
)

export default component.exports